import { h } from 'preact'
import { useState, useEffect } from 'preact/compat'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import ErrorMessage from '../../Common/ErrorMessage'
import { useTranslations } from '../../../hooks/useTranslations'
import { pageStateSelector } from '../../../redux/slice/pageStateSlice'
import { DataDog } from '../../../datadog'
import {
  dispatchMFEAdobeEvent,
  dispatchMFEEvent,
} from '../../../helpers/events'
import './styles.scss'

export default function CustomPaymentMethod({ paymentMethod }) {
  const l10n = useTranslations()
  const [error, setError] = useState('')
  const pageState = useSelector(pageStateSelector)

  useEffect(() => {
    if (!pageState.isPaymentBlocked) {
      setError('')
    }
  }, [pageState.isPaymentBlocked])

  const handlePayment = () => {
    DataDog.info(`${paymentMethod} payment button clicked`)
    dispatchMFEEvent('tui-button.payment-btn-clicked', { paymentMethod })
    dispatchMFEAdobeEvent(`Pay-${paymentMethod}`)

    if (pageState.isPaymentBlocked) {
      setError(l10n.t('payment-btn-error'))
      return
    }

    setError('')
  }

  return (
    <div className="custom-payment-method-wrapper">
      <ErrorMessage
        isShown={!!error}
        message={error}
        data-testid="custom-payment-method-error"
      />

      <div className="custom-payment-method-button">
        <button
          type="button"
          className="button primary medium"
          data-testid="custom-payment-method-button"
          onClick={handlePayment}
        >
          {l10n.t('Pay Now')}
        </button>
      </div>
    </div>
  )
}

CustomPaymentMethod.propTypes = {
  paymentMethod: PropTypes.string,
}
